import { ApiClientService, EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class ActorProcessApiService extends EntityApiService {

  search = (params, config) => {
    return ApiClientService.get(this.getPath('?admin=true'), params, config);
  }

  searchReduced = (params, config) => {
    return ApiClientService.post(this.getPath('/search'), params, config);
  }

  updateSteps = (params, config) => {
    return ApiClientService.patch(this.getPath('/steps'), params, config);
  }

  updateFields = (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/steps/${id}`), params, config);
  }

  getOne = (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.get(this.getPath(`/steps/${id}`), params, config);
  }
}

export default new ActorProcessApiService(`${authentication.path}/api/process`);
